import { ProfileModel } from '@pukka/api';
import { format } from 'date-fns';

import { getDeviceType } from './getDeviceType';

import { pushClevertapEvent } from '.';

function createCDSCampaignEvent(numberOfImage: number, outletIds: number[], profile: ProfileModel.Response | undefined) {
  pushClevertapEvent('[CDS] Campaign Created', {
    'Outlet ID': outletIds,
    Date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
    Device: getDeviceType(),
    'Phone Number': profile?.phone,
    Email: profile?.email,
    'User Role': profile?.role_name,
    'Number of Image': numberOfImage,
  });
}

export { createCDSCampaignEvent };
